export * from './detail-controller.can-deactivate';
export * from './detail-controller.relsovers';
export * from './title-page';
